<template>
  <div>
    <headers />
    <el-breadcrumb separator-class="el-icon-arrow-right" class="containers breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>课堂</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="sequence containers">
      <dl class="clearfix">
        <dt>授课方式：</dt>
        <dd class="clearfix">
          <span :class="[typeindex == ''?'on':'']" @click="typefunc('')">全部</span>
          <span :class="[typeindex == 1?'on':'']" @click="typefunc(1)">点播课程</span>
          <span :class="[typeindex == 2?'on':'']" @click="typefunc(2)">直播课程</span>
          <span :class="[typeindex == 3?'on':'']" @click="typefunc(3)">预约课程</span>
        </dd>
      </dl>
      <dl class="clearfix on">
        <dt>课程分类：</dt>
        <dd class="clearfix">
          <span
            @click="daidfunc(item.id,index)"
            :class="[index == daid_index?'on':'' ]"
            v-for="(item,index) in fenlei"
            :key="item.id"
            :data-id="item.id"
            v-if="index <= more"
          >{{item.title}}</span>
          <div class="itembox" @click="more = Infinity" v-if="more != Infinity">更多</div>
        </dd>
      </dl>
      <dl class="clearfix">
        <dt></dt>
        <dd class="clearfix" v-if="fenlei[daid_index] != undefined">
          <span
            v-for="(item,index) in fenlei[daid_index].child"
            :key="item.id"
            :data-id="item.id"
            @click="xiaoidfunc(item.id,index)"
            :class="[index == xiaoid_index?'on':'' ]"
          >{{item.title}}</span>
        </dd>
      </dl>
    </div>
    <div class="containers clearfix">
      <div class="sign">
        <div :class="['condition',zongheindex==0?'on':'']" @click="zonghe(0,0)">综合</div>
        <div :class="['condition',zongheindex==1?'on':'']" @click="zonghe(1,2)">最新</div>
        <div :class="['condition',zongheindex==2?'on':'']" @click="zonghe(2,1)">最热</div>
        <div :class="['condition',zongheindex==3?'on':'']" @click="zonghe(3,5)">
          评价
          <!-- 降序 -->
          <i class="iconfont icon-xia" v-if="pingjia == false"></i>
          <!-- 升序 -->
          <!-- <i class="el-icon-top" v-if="pingjia == true"></i> -->
        </div>
        <!-- 3价格升序和4价格降序 -->
        <div :class="['condition',zongheindex==4?'on':'']" @click="zonghe(4,3)">
          价格
          <!-- 降序4 -->
          <i class="iconfont icon-sort-bottom-copy" v-if="jiage == false"></i>
          <!-- 升序3 -->
          <i class="iconfont icon-desc" v-if="jiage == true"></i>
        </div>
      </div>
      <div class="swich">
        <el-switch v-model="switchs" active-text="隐藏已购" inactive-text></el-switch>
      </div>
    </div>
    <div class="selectedclass">
      <div class="containers">
        <ul class="pubilcul clearfix active">
          <router-link
            :to="{path:'/detailsclass',query:{id:item.id}}"
            tag="li"
            v-for="(item) in listbox"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic">
              <img :src="item.imgUrl" alt srcset />
              <div class="type" v-if="item.type == 1">点播课程</div>
              <div class="type" v-if="item.type == 2">直播课程</div>
              <div class="type" v-if="item.type == 3">线下课程</div>
            </div>
            <div class="infos">
              <h3>{{item.title}}</h3>
              <div class="spans clearfix">
                <span class="money">{{item.price == 0?'免费':'¥'+item.price}}</span>
                <span class="number">
                  <i class="el-icon-user-solid"></i>
                  {{item.count}}
                </span>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
      <div class="pageing">
        <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
        <el-pagination
          small
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :background="true"
          :total="totaldata.total_pages"
          :page-size="1"
          @current-change="currentchange"
          :current-page="page"
        ></el-pagination>
        <span @click="pageend" class="spansx" :class="[page == totaldata.total_pages?'on':'']">尾页</span>
      </div>
      <footers />
    </div>
  </div>
</template>

<script>
import {
  Breadcrumb,
  BreadcrumbItem,
  Switch,
  Pagination,
  MessageBox
} from "element-ui";
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    headers,
    footers,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Switch.name]: Switch,
    [Pagination.name]: Pagination,
    [MessageBox.name]: MessageBox
  },
  inject: ["reload"], // 引入方法
  data() {
    return {
      switchs: false,
      fenlei: "", //分类
      daid_index: 0, //大分类索引
      daid: 0, //大分类id
      xiaoid_index: 0, //小分类索引
      xiaoid: 0, //小分类id
      zongheindex: 0, //综合索引
      jiage: false, //true 升序 false降序
      pingjia: false, //true 升序 false降序
      zonghenum: 0, //综合传的值
      page: 1,
      listbox: [],
      typeindex: "",
      kechengid: "",
      total_pages: 0,
      is_buy: 0, //1是已购买 不传是 未购买
      isLogin: false,
      totaldata: {},
      more: 10 //点击更多的时候使用
    };
  },
  watch: {
    typeindex(newvalue) {
      this.page = 1;
      this.typeindex = newvalue;
      this.listfunc();
    },
    daid(newvalue) {
      this.page = 1;
      this.fenlei.forEach((item, index) => {
        if (item.id == newvalue) {
          this.daid_index = index;
        }
      });

      //this.kechengid = newvalue;
      //this.listfunc();
    },
    xiaoid(newvalue) {

      this.page = 1;
      this.fenlei.forEach((item, index) => {
        item.child.forEach((itemson, indexson) => {
          if (itemson.id == newvalue) {
            this.xiaoid_index = indexson;
          }
        });
      });
      this.kechengid = newvalue;
      this.listfunc();
    },
    switchs(newvalue) {
      this.page = 1;
      if (newvalue) {
        if (this.isLogin) {
          //需要判断是不是登录状态
          this.is_buy = 1;
          this.listfunc();
        } else {
          MessageBox.confirm("请先登录", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.$router.push({
                path: "/logins"
              });
            })
            .catch(() => {
              this.switchs = false;
            });
        }
      } else {
        this.is_buy = 0;
      }
      this.listfunc();
    },
    page(newvalue) {
      this.page = newvalue;
      this.listfunc();
    },
    $route(to) {
      //同一个页面刷新
      if (to.query.typeindex) {
        this.reload();
      } else if (to.path == "/classlistarr") {
        this.reload();
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (this.typeindex) {
      this.typeindex = to.query.typeindex;
    }
    if (this.daid) {
      this.daid = to.query.daid;
    }
    if (this.xiaoid) {
      this.xiaoid = to.query.xiaoid;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.typeindex) {
      to.query.typeindex = this.typeindex;
    }
    if (this.daid) {
      to.query.daid = this.daid;
    }
    if (this.xiaoid) {
      to.query.xiaoid = this.xiaoid;
    }
    next();
  },

  methods: {
    typefunc(index) {
      this.typeindex = index;
    },

    async fenleifunc() {
      //分类
      await this.$axios({
        method: "post",
        url: `/index/course.category`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        var obj = {
          id: "",
          title: "全部",
          child: [
            {
              id: "",
              title: "全部"
            }
          ]
        };
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        totaldata.unshift(obj);
        totaldata.forEach((item, index) => {
          if (index != 0) {
            if (item.child) {
              item.child.unshift({ id: item.id, title: "全部" });
            } else {
              item.child = [];
              item.child.unshift({ id: item.id, title: "全部" });
            }
          }
        });
        this.fenlei = totaldata;

        if (this.$route.query.typeindex) {
          this.typeindex = this.$route.query.typeindex;
        }
        if (this.$route.query.daid) {
          this.daid = this.$route.query.daid;
        }
        if (this.$route.query.xiaoid) {
          this.xiaoid = this.$route.query.xiaoid;
        }
        
      });
    },
    daidfunc(id, index) {

      //this.daid = id;
      this.daid_index = index;
      this.xiaoid = this.fenlei[index].child[0].id;

    },
    xiaoidfunc(id, index) {
      this.xiaoid = id;
      this.xiaoid_index = index;
    },
    zonghe(index, num) {
      this.zongheindex = index;
      if (index == 4) {
        this.jiage = !this.jiage;
        if (this.jiage) {
          //升序
          this.zonghenum = 3;
        } else {
          this.zonghenum = 4;
        }
      } else {
        this.zonghenum = num;
      }
      this.listfunc();
    },
    //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.totaldata.total_pages;
    },
    async listfunc() {
      var data = {
        type: this.typeindex,
        categoryid: this.kechengid,
        sequence: this.zonghenum,
        page: this.page,
        is_buy: this.is_buy
      };
      data = utilFile.encrypt(JSON.stringify(data));
      await this.$axios({
        method: "post",
        url: `/index/course.list?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
          this.totaldata = totaldata;
          this.listbox = totaldata.arr;
          this.count = totaldata.total_pages;
        }
      });
    },
    user() {
      this.$axios({
        method: "post",
        url: `/api/user.infomation`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.isLogin = false;
        } else {
          this.isLogin = true;
        }
      });
    }
  },
  async mounted() {
    await this.fenleifunc(); //分类
    await this.listfunc(); //列表
    this.user();
  }
};
</script>

<style scoped>
@import "~@/assets/css/common.css";
.breadcrumb {
  margin-top: 26px;
  margin-bottom: 24px;
}

h2.newtitle {
  text-align: left;
  margin-top: 44px;
  margin-bottom: 30px;
}

/*  */
.pubilcul li {
  float: left;
  width: 19%;
  margin-right: 1.25%;
  margin-bottom: 30px;
  background-color: #fff;
  padding-bottom: 15px;
  cursor: pointer;
}

.pubilcul li:nth-of-type(5n) {
  margin-right: 0;
}

.pubilcul li .pic {
  height: 160px;
}

.pubilcul li .pic img {
  max-height: 100%;
}

.pubilcul li .infos {
  box-sizing: border-box;
  padding-left: 12px;
  padding-right: 12px;
}

.pubilcul li .infos h3 {
  font-size: 16px;
  color: #1b1f22;
  margin-top: 10px;
  margin-bottom: 29px;
  text-align: left;
  line-height: 1.5em;
  height: 52px;
  font-weight: bold;
}

.pubilcul li .infos .money {
  float: left;
  font-size: 20px;
  color: red;
  line-height: 20px;
}

.pubilcul li .infos .number {
  float: right;
  font-size: 14px;
  color: #878787;
  line-height: 20px;
}

.pubilcul li .infos .number i {
  color: #c9cbd1;
}

.pubilcul.active li .pic {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  height: 130px;
}

.pubilcul.active li .pic img {
  min-height: 100%;
}

.pubilcul.active li .pic .type {
  font-size: 14px;
  color: #fff;
  line-height: 2em;
  padding: 0 10px;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 11px;
  top: 10px;
}

/*  */

.sign .condition i {
  color: #6c6c6c;
}
.sign .condition.on i {
  color: #fff;
}
</style>
<style>
.el-switch__core {
  width: 32px !important;
  height: 13px;
  background-color: #a0a0a0 !important;
}

.el-switch__core:after {
  top: -5px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 1px solid #a0a0a0;
  left: 0;
}

.is-checked .el-switch__core {
  width: 32px !important;
  height: 13px;
  background-color: #dff0ff !important;
}

.is-checked .el-switch__core:after {
  top: -5px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 1px solid #38a0ff;
  left: 0;
}

.el-switch__label.is-active {
  color: #3e3e3e;
}
</style>